import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Users, UserRole } from 'src/app/models/users';
import { environment } from 'src/environments/environment';
import { Constant } from '../constant/constant';


@Injectable({
	providedIn: 'root'
})
export class UsersService {


	addressIndex = new Subject<any>();
	constructor(private http: HttpClient) { }

	url = environment.serverAPI1 + "/api";

	url2 = environment.serverAPI4 + "/api/location";

	url5 = environment.serverAPI + "/api/auth";

	url4 = environment.serverAPI2 + "/api/auth";

	url6 = environment.serverAPI + "/api";

	url7 = environment.serverAPI1 + "/api/customer";

	url8 = environment.serverAPI4 + "/api/user";

	url9 = environment.serverAPI + "/api/auth";


	getUserBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/customer/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	emailVerified(email: any): Observable<Object> {
		return this.http.get(`${this.url5}/customer/username/${email}`);
	}

	getCustomers(Page: number, size: number, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/customer/idx/all?page=${Page}&size=${size}&sort=${sort}`);
	}

	getCustomersList(isActive): Observable<Object> {
		return this.http.get(`${this.url}/customer/idx/all/list/${isActive}`);
	}

	getCustomersDropdownBasedOnType(type): Observable<Object> {
		return this.http.get(`${this.url9}/access/dropdown/${type}`);
	}

	getBillerUsersDropdown(warehouseId?: any): Observable<Object> {
		let queryParams = '';
		if (warehouseId) {
			queryParams = `?warehouseId=${warehouseId}`;
		}
		return this.http.get(`${this.url9}/access/biller/dropdown${queryParams}`);
	}




	downloadReport(): Observable<any> {
		return this.http.get(`${this.url}/customer/export`, { responseType: 'arraybuffer', observe: 'response' });
	}

	downloadCustomerReport(Page: number, size: number, sort, selectionOrder): Observable<any> {
		return this.http.post(`${this.url}/customer/export?page=${Page}
		&size=${size}&sort=${sort}`, selectionOrder, {
			responseType: 'arraybuffer',
			observe: 'response'
		});
	}

	createCustomers(user: Users): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/ig/customers`, user);
	}
	updateCustomers(user: Users): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/customers`, user);
	}

	addPatientsEntity(user): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/customers`, user);
	}

	updateCustomersViaProfile(user: Users): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/customers/profile`, user);
	}

	getUserById(customerId: number): Observable<Object> {
		return this.http.get(`${this.url}/customers/${customerId}`);
	}

	getPincode(pincode: number): Observable<Object> {
		return this.http.get(`${this.url2}/${pincode}`);
	}


	getUserRoles(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url5}/access/?page=${Page}&size=${size}&sort=${sort}`);
	}

	getUserRolesForDashBoard(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url6}/access/common?page=${Page}&size=${size}&sort=${sort}`);
	}

	searchUserRole(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url5}/access/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getAuthority(): Observable<Object> {
		return this.http.get(`${this.url5}/authority`);
	}
	getAuthorityById(id: number): Observable<Object> {
		return this.http.get(`${this.url5}/authority/${id}`);
	}

	createUserRole(userRole: UserRole): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url5}/access`, userRole);
	}

	disableUserTwoFactor(userId: number): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url5}/access/${userId}/2fa/disable`, {});
	}


	getUserRoleById(id: number): Observable<Object> {
		return this.http.get(`${this.url5}/access/${id}`);
	}



	///
	resetPassword(user: Users): Observable<Response[]> {

		return this.http.post<Response[]>(`${this.url6}/auth/changePassword`, user);

	}

	getLoggedInUserData(): Observable<Object> {
		return this.http.get(`${this.url}/customers/details`);
	}

	customerNumberCheck(userName: any): Observable<Object> {

		return this.http.get(`${this.url5}/verify/telephone/${userName}`);

	}

	generateReferalId(): Observable<Object> {

		return this.http.get(`${this.url5}/generate/referralid`);

	}

	getAllUserStatusDropDown(): Observable<Object> {


		return this.http.get(`${this.url8}/dropdown`);
	}

	getAllUserStatusDropDownSales(): Observable<Object> {

		return this.http.get(`${this.url8}/dropdown/sales`);
	}

	getAllUserListSolr(): Observable<Object> {
		return this.http.get(`${this.url8}/dropdown/solr`);
	}

	getUserAutocomplete(q: string, limit: number = 10): Observable<Object> {
		return this.http.get(`${this.url8}/dropdown/autocomplete?q=${encodeURIComponent(q)}&limit=${limit}`);
	}



	getCrmUserRolesForDashBoard(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url8}/crm?page=${Page}&size=${size}&sort=${sort}`);
	}

	getAllSiteCustomers(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url8}/order?page=${Page}&size=${size}&sort=${sort}`);
	}

	getAuthenticatedUser() {
		let userName = null;
		if (Constant.DEVICE_TYPE == "MOBILE") {
			userName = localStorage.getItem("authenticaterUser");
		} else {
			userName = this.getCookie("user-name");
		}
		return userName;
	}

	getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	getAuthenticatedUserEmail() {
		let userName = null;
		if (Constant.DEVICE_TYPE == "MOBILE") {
			userName = localStorage.getItem("authenticaterUserEmail");
		} else {
			userName = this.getCookie("email");
		}
		return userName;
	}

	url3 = environment.serverAPI1 + "/api/customers";
	deleteCustomer(addressId: any): Observable<Object> {
		return this.http.delete(`${this.url3}/${addressId}`);
	}

	storeProductCartCount(i) {
		sessionStorage.setItem(Constant.CART_COUNT, i);
		return true;
	}


	deleteById(customerId: number): Observable<Object> {
		return this.http.delete(`${this.url5}/access/${customerId}`);
	}

	savePushtoken(data: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url6}/push/notification`, data);
	}


	  forgotPassword(email: any): Observable<Object> {
    return this.http.get(`${this.url9}/forgetpassword/${email}`);
  }

  verifyForgotPasswordToken(user: any): Observable<Object> {
    return this.http.post(`${this.url9}/password/verifyToken`, user);
  }

  changePassword(user: any): Observable<Object> {
    return this.http.post(`${this.url9}/changePassword`, user);
  }


}



